var render = function (_h,_vm) {var _c=_vm._c;return _c('nav',_vm._g(_vm._b({},'nav',_vm.data.attrs,false),_vm.listeners),[_c('ul',{staticClass:"nav nav-sidebar nav-pills flex-column"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }